
interface ServiceDetailProps {
  service: {
    id: string;
    title: string;
    subtitle: string;
    description: string;
    features: Array<{ icon: string; text: string }>;
    image: string;
    benefits: string[];
  };
  index: number;
}

export default function ServiceDetail({ service, index }: ServiceDetailProps) {
  const isEven = index % 2 === 0;

  return (
    <section id={service.id} className={`py-24 ${isEven ? 'bg-white' : 'bg-warm-50'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${isEven ? '' : 'lg:flex-row-reverse'}`}>
          <div className={`${isEven ? 'lg:order-1' : 'lg:order-2'}`}>
            <div className="inline-block px-4 py-2 bg-primary/10 text-primary rounded-full text-sm font-medium mb-4">
              {service.title}
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-primary mb-4 font-serif">
              {service.subtitle}
            </h2>
            <p className="text-base text-gray-600 leading-relaxed mb-8">
              {service.description}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              {service.features.map((feature, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                    <i className={`${feature.icon} text-lg text-primary`}></i>
                  </div>
                  <span className="text-sm text-gray-700 pt-2">{feature.text}</span>
                </div>
              ))}
            </div>

            <div className="bg-warm-100/50 rounded-2xl p-6 mb-8">
              <h4 className="text-lg font-bold text-primary mb-4 flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-primary"></i>
                服務優勢
              </h4>
              <ul className="space-y-2">
                {service.benefits.map((benefit, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                    <i className="ri-check-line text-primary"></i>
                    {benefit}
                  </li>
                ))}
              </ul>
            </div>

            <a
              href="https://lin.ee/JAWndnI"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-white rounded-full text-base font-medium hover:bg-primary/90 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-message-3-line"></i>
              立即諮詢此服務
            </a>
          </div>

          <div className={`${isEven ? 'lg:order-2' : 'lg:order-1'}`}>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
